<template>
  <div class="main-links">
    <a 
      v-for="(link, index) in navLinks"
      :key="index"
      :href="link.url"
      target="_blank"
      class="main-links-item"> 
      <span 
        class="main-links-item-icon"
        :style="`mask: url(data:image/svg+xml;base64,${link.icon}) no-repeat center; mask-size: contain;`"
      ></span>
      {{ link.name }}
    </a>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, Ref } from 'vue';
import store                              from '@/store';
import { ILinkElement } from '@/interfaces/ILinkElement';

const MainLinks: object = defineComponent({
  props: {
  },
  setup() {
    const navLinks: Ref<ILinkElement[]> = computed(
      () => store.state.links.sort((a, b) => a.order - b.order).filter((link) => link.category === 'menu'
    ));
    return {
      navLinks,
    };
  },
});
export default MainLinks;
</script>

<style scoped lang="scss">
.main-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: rem(16px);

  @include width-until($mobile) {
    flex-direction: column;
  }

  @include width-from($mobile) {
    justify-content: center;
  }

  &-item {
    text-decoration: none;
    color: $white-static;
    font-weight: 500;
    margin-left: 20px;
    display: flex;
    align-items: center;

    &:hover {
      color: $font-hover;
    }

    &-icon {
        width: rem(20px);
        height: rem(20px);
        display: inline-block;
        margin-right: rem(8px);
        background-color: currentColor;
      }

    @include width-until($mobile) {
      margin-left: 0;
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    &:hover {
      
    }
  }
}
</style>
